__turbopack_context__.v({
  "details": "productCardHorizontal-module__EGmJUG__details",
  "price": "productCardHorizontal-module__EGmJUG__price",
  "priceBlock": "productCardHorizontal-module__EGmJUG__priceBlock",
  "remove": "productCardHorizontal-module__EGmJUG__remove",
  "root": "productCardHorizontal-module__EGmJUG__root",
  "strikeout": "productCardHorizontal-module__EGmJUG__strikeout",
  "subtitle": "productCardHorizontal-module__EGmJUG__subtitle",
  "thumb": "productCardHorizontal-module__EGmJUG__thumb",
  "thumbIcon": "productCardHorizontal-module__EGmJUG__thumbIcon",
  "thumbImage": "productCardHorizontal-module__EGmJUG__thumbImage",
  "title": "productCardHorizontal-module__EGmJUG__title",
});
